<p
  *ngIf="address else emptyAddressField"
  class="mb-0 text-truncate"
>{{ address }}</p>
<ng-template #emptyAddressField><br></ng-template>
